import { render } from "./FomoButton.vue?vue&type=template&id=87b9ff62"
import script from "./FomoButton.vue?vue&type=script&lang=js"
export * from "./FomoButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__